// these modules are duplicated a lot across the bundles but are in all the boot bundles
// including them here won't hurt boot size but will decrease duplication
import {
    Dialog as DialogV19,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Label as LabelV9,
    Listbox,
    MessageBar,
    Option,
    Popover,
    PopoverSurface,
    Skeleton,
    SkeletonItem,
    Tooltip as TooltipV9,
    Spinner as SpinnerV9,
} from '@fluentui/react-components';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing ChoiceGroup from '@fluentui/react', as this package has started migration to Fluent UI 9. Import RadioGroup from '@fluentui/react-components' instead. */
import { ChoiceGroup } from '@fluentui/react/lib/ChoiceGroup';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing ComboBox from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Combobox from '@fluentui/react-components' instead. */
import { ComboBox } from '@fluentui/react/lib/ComboBox';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing DatePicker from '@fluentui/react', as this package has started migration to Fluent UI 9. Import DatePicker from '@fluentui/react-datepicker-compat' instead. */
import { DatePicker } from '@fluentui/react/lib/DatePicker';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Dialog from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Dialog from '@fluentui/react-components' instead. */
import { Dialog } from '@fluentui/react/lib/Dialog';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Dropdown from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Dropdown from '@fluentui/react-components' instead. */
import { Dropdown } from '@fluentui/react/lib/Dropdown';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Label from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Label from '@fluentui/react-components' instead. */
import { Label } from '@fluentui/react/lib/Label';
import { List } from '@fluentui/react/lib/List';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Modal from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Dialog from '@fluentui/react-components' instead. */
import { Modal } from '@fluentui/react/lib/Modal';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Overlay from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Portal from '@fluentui/react-components' instead. */
import { Overlay } from '@fluentui/react/lib/Overlay';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Panel from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Drawer from '@fluentui/react-components' instead. */
import { Panel } from '@fluentui/react/lib/Panel';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Persona from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Persona from '@fluentui/react-components' instead. */
import { Persona } from '@fluentui/react/lib/Persona';
import { ResizeGroup } from '@fluentui/react/lib/ResizeGroup';
import { Selection } from '@fluentui/react/lib/Selection';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Shimmer from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Skeleton from '@fluentui/react-components' instead. */
import { Shimmer } from '@fluentui/react/lib/Shimmer';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Spinner from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Spinner from '@fluentui/react-components' instead. */
import { Spinner } from '@fluentui/react/lib/Spinner';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing TextField from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Input from '@fluentui/react-components' instead. */
import { TextField } from '@fluentui/react/lib/TextField';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Toggle from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Switch from '@fluentui/react-components' instead. */
import { Toggle } from '@fluentui/react/lib/Toggle';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Tooltip from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Tooltip from '@fluentui/react-components' instead. */
import { Tooltip, TooltipHost } from '@fluentui/react/lib/Tooltip';

// by exporting this const, this prevents from tree shaking
// as all of these have sideEffects turned off
export const commonDuplicatedModules: unknown[] = [
    DatePicker,
    DialogV19,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Listbox,
    Option,
    ChoiceGroup,
    ComboBox,
    Dialog,
    Dropdown,
    Label,
    LabelV9,
    List,
    MessageBar,
    Modal,
    Overlay,
    Panel,
    Persona,
    Popover,
    PopoverSurface,
    ResizeGroup,
    Selection,
    Shimmer,
    Skeleton,
    SkeletonItem,
    Spinner,
    SpinnerV9,
    TextField,
    Toggle,
    Tooltip,
    TooltipV9,
    TooltipHost,
];
